module.exports = __webpack_public_path__ + "img/preview_multi_line_text.ed44a5fb.png";